export default __webpack_public_path__ + "static/media/0x6e7a5fafcec6bb1e78bae2a1f0b612012bf14827.8614d7eb.svg";